import React from "react";
import classNames from "classnames";
import ATitle from "../../components/ATitle";

function Vote({ className, title, subtitle, children }) {
  return (
    <form className={classNames("v-form", { [className]: !!className })}>
      <ATitle text={title} />
      <p className="v-form__subtitle">{subtitle}</p>
      <div className="v-form__list">{children}</div>
    </form>
  );
}

export default Vote;
